import React, { useState } from 'react';
import { Dropdown, Checkbox, Button, Space, theme } from 'antd';
import {
    PlusOutlined,
  } from '@ant-design/icons';
import { trackEvent } from "../utils/util-functions";
import { ReactComponent as PythonForexIcon } from '../../assets/logos/python-forex.svg';
import { ReactComponent as TransliterateIcon } from '../../assets/logos/transliteration.svg';
import { ReactComponent as IndicTransliterateIcon } from '../../assets/logos/indic-transliterate.svg';
import pymysqlLogo from "../../assets/logos/pymysql-logo.png";

const { useToken } = theme;

const PluginsLoader = (props) => {
  const [open, setOpen] = useState(false);
  const [checkboxObj, setChecked] = useState({
    'NumPy': false,
    'Pandas': false,
    'Matplotlib': false,
    'scikit-learn': false,
    'requests': false,
    'pygame': false,
    'forex-python': false,
    'transliterate': false,
    'tensorflow': false,
    'indic-transliteration': false,
    'mysqlConnector': false,
    'opencv-python': false,
    'wikipedia': false,
  });


  const handleMenuClick = (packageName) => {
    // if(!checkboxObj[packageName]){
    //     if(!pluginsList.includes(checkboxObj[packageName])){
    //         pluginsList.push(checkboxObj[packageName])
    //     }
    // }
    trackEvent("ide_install_package_clicked", {
      ide_project_stack_name: props.ideProjectStackName,
      packageName
    });
    setChecked(prevState => {
        const newState = { ...prevState }; // Create a copy of the state object
        newState[packageName] = !newState[packageName]; // Toggle the checkbox value
        return newState; // Set the updated state
    });
  };

  const handleSubmitPackages = () => {
    const packages = Object.entries(checkboxObj)
      .filter(([_, checked]) => checked)
      .map(([pkg]) => pkg);
  
    props.submittedPackages(packages)
    setOpen(false)
  }
  

  const handleOpenChange = open => {
    if(open){
       let checkObj = { ...checkboxObj };
        Object.keys(checkObj).forEach(key => {
            if(props.selectedPackagesList.includes(key)){
                checkObj[key] = true;
            } else {
                checkObj[key] = false;
            }
            setChecked(checkObj)
        });
    }

    setOpen(open);
  };
  const { token } = useToken();

  const contentStyle = {
    width: '350px',
    controlItemBgActive: '#bae0ff',
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
    display: 'flex', // Add flex display
    flexDirection: 'column', // Align items vertically
  };

  const menuStyle = {
    boxShadow: 'none',
    maxHeight: '400px',
    overflowY: 'auto',
  };

  const items = [
    {
      key: '1',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{cursor: 'auto'}}>
            <div className='col-1'>
                <Checkbox
                    checked={checkboxObj.NumPy}
                    onChange={()=>{
                        handleMenuClick('NumPy')
                    }}
                ></Checkbox>
            </div>

            <div className='col-1'>
                <img 
                    src={'https://seeklogo.com/images/N/numpy-logo-479C24EC79-seeklogo.com.png'} 
                    alt="" 
                    style={{
                        top: '50%',
                        width: '20px',
                        height: '20px',
                    }}
                />
            </div>

            <div className='col-10' style={{paddingLeft:'20px'}}>
                <span>NumPy</span><br/>
                <span className='text-muted text-break'>A fundamental library for numerical computing in Python, providing support for arrays and matrices</span>
                <div className='wrap-addplugin' onClick={()=>{
                    handleMenuClick('NumPy')
                  }}>
                    {checkboxObj.NumPy &&(
                        <span>Remove</span>
                    )}

                    {!checkboxObj.NumPy &&(
                        <span>Add</span>
                    )}
                </div>
            </div>
        </div>
      ),
    },
    
    {
        key: '2',
        colorBgElevated: '#232F34',
        label: (
          <div className='row plugin-item' style={{cursor: 'auto'}}>
              <div className='col-1'>
                    <Checkbox 
                        checked={checkboxObj.Pandas} 
                        onChange={()=>{
                            handleMenuClick('Pandas')
                        }}
                    ></Checkbox>
              </div>
  
              <div className='col-1'>
                  <img 
                      src={'https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Pandas_mark.svg/1200px-Pandas_mark.svg.png'} 
                      alt="" 
                      style={{
                          top: '50%',
                          width: '20px',
                          height: '20px',
                      }}
                  />
              </div>
  
              <div className='col-10' style={{paddingLeft:'20px'}}>
                  <span>Pandas</span><br/>
                  <span className='text-muted text-break'>A powerful data manipulation and analysis library for handling structured data using Series and DataFrame.</span>
                  <div className='wrap-addplugin' onClick={()=>{
                    handleMenuClick('Pandas')
                  }}>
                        {checkboxObj.Pandas &&(
                            <span>Remove</span>
                        )}

                        {!checkboxObj.Pandas &&(
                            <span>Add</span>
                        )}
                  </div>
              </div>
          </div>
        ),
      },

    {
        key: '3',
        colorBgElevated: '#232F34',
        label: (
          <div className='row plugin-item' style={{cursor: 'auto'}}>
              <div className='col-1'>
                    <Checkbox 
                        checked={checkboxObj.Matplotlib}
                        onChange={()=>{
                            handleMenuClick('Matplotlib')
                        }}
                    >
                    </Checkbox>
              </div>
  
              <div className='col-1'>
                  <img 
                      src={'https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Matplotlib_icon.svg/1200px-Matplotlib_icon.svg.png'} 
                      alt="" 
                      style={{
                          top: '50%',
                          width: '20px',
                          height: '20px',
                      }}
                  />
              </div>
  
              <div className='col-10' style={{paddingLeft:'20px'}}>
                  <span>Matplotlib</span><br/>
                  <span className='text-muted text-break'>A versatile plotting library for creating static, interactive, and animated visualizations in Python. </span>
                  <div className='wrap-addplugin' onClick={()=>{
                    handleMenuClick('Matplotlib')
                  }}>
                        {checkboxObj.Matplotlib &&(
                            <span>Remove</span>
                        )}

                        {!checkboxObj.Matplotlib &&(
                            <span>Add</span>
                        )}
                  </div>
              </div>
          </div>
        ),
    },
    {
      key: '4',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{cursor: 'auto'}}>
            <div className='col-1'>
                  <Checkbox 
                      checked={checkboxObj['scikit-learn']}
                      onChange={() => {
                          handleMenuClick('scikit-learn')
                      }}
                  >
                  </Checkbox>
            </div>
    
            <div className='col-1'>
                <img 
                    src={'https://scikit-learn.org/stable/_static/scikit-learn-logo-small.png'} 
                    alt="" 
                    style={{
                        top: '50%',
                        width: '20px',
                        height: '20px',
                    }}
                />
            </div>
    
            <div className='col-10' style={{paddingLeft:'20px'}}>
                <span>scikit-learn</span><br/>
                <span className='text-muted text-break'>Want to build AI? Start with Scikit-Learn—an easy, powerful tool for machine learning & data science</span>
                <div className='wrap-addplugin' onClick={() => {
                  handleMenuClick('scikit-learn')
                }}>
                      {checkboxObj['scikit-learn'] &&(
                          <span>Remove</span>
                      )}
    
                      {!checkboxObj['scikit-learn'] &&(
                          <span>Add</span>
                      )}
                </div>
            </div>
        </div>
      ),
    },
    {
      key: '5',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox 
              checked={checkboxObj['requests']}
              onChange={() => {
                handleMenuClick('requests');
              }}
            />
          </div>
    
          <div className='col-1'>
            <img 
              src="https://cdn.worldvectorlogo.com/logos/python-5.svg" 
              alt="Requests Logo" 
              style={{
                top: '50%',
                width: '20px',
                height: '20px',
              }}
            />
          </div>
    
          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>requests</span><br />
            <span className='text-muted text-break'>
              A simple and elegant HTTP library for Python, used to make API calls and web requests.
            </span>
            <div className='wrap-addplugin' onClick={() => {
              handleMenuClick('requests');
            }}>
              {checkboxObj['requests'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '6',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox
              checked={checkboxObj['pygame']}
              onChange={() => {
                handleMenuClick('pygame');
              }}
            />
          </div>
    
          <div className='col-1'>
            <img
              src="https://www.pygame.org/docs/_images/pygame_logo.png"
              alt="Pygame Logo"
              style={{
                width: '20px',
                height: '20px',
              }}
            />
          </div>
    
          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>pygame</span><br />
            <span className='text-muted text-break'>
              A set of Python modules designed for writing video games and multimedia applications.
            </span>
            <div className='wrap-addplugin' onClick={() => handleMenuClick('pygame')}>
              {checkboxObj['pygame'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '7',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox
              checked={checkboxObj['forex-python']}
              onChange={() => {
                handleMenuClick('forex-python');
              }}
            />
          </div>
    
          <div className='col-1'>
            <PythonForexIcon style={{ width: '20px', height: '20px' }}/>
          </div>
    
          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>forex-python</span><br />
            <span className='text-muted text-break'>
              A library for real-time currency conversion and exchange rate fetching using online APIs like exchangeratesapi.io.
            </span>
            <div className='wrap-addplugin' onClick={() => handleMenuClick('forex-python')}>
              {checkboxObj['forex-python'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '8',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox
              checked={checkboxObj['transliterate']}
              onChange={() => {
                handleMenuClick('transliterate');
              }}
            />
          </div>
    
          <div className='col-1'>
            <TransliterateIcon style={{ width: '20px', height: '30px' }}/>
          </div>
    
          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>transliterate</span><br />
            <span className='text-muted text-break'>
              A module for language transliteration, commonly used to convert text from one script to another.
            </span>
            <div className='wrap-addplugin' onClick={() => handleMenuClick('transliterate')}>
              {checkboxObj['transliterate'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '9',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox
              checked={checkboxObj['tensorflow']}
              onChange={() => {
                handleMenuClick('tensorflow');
              }}
            />
          </div>
    
          <div className='col-1'>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg"
              alt="TensorFlow Logo"
              style={{ width: '20px', height: '20px' }}
            />
          </div>
    
          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>TensorFlow</span><br />
            <span className='text-muted text-break'>
              An end-to-end open-source machine learning framework used for training and deploying deep learning models.
            </span>
            <div className='wrap-addplugin' onClick={() => handleMenuClick('tensorflow')}>
              {checkboxObj['tensorflow'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '10',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox
              checked={checkboxObj['indic-transliteration']}
              onChange={() => {
                handleMenuClick('indic-transliteration');
              }}
            />
          </div>
    
          <div className='col-1'>
            <IndicTransliterateIcon style={{ width: '20px', height: '30px' }}/>
          </div>
    
          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>indic-transliteration</span><br />
            <span className='text-muted text-break'>
              A transliteration library for Indian languages supporting Devanagari, Tamil, and more.
            </span>
            <div className='wrap-addplugin' onClick={() => handleMenuClick('indic-transliteration')}>
              {checkboxObj['indic-transliteration'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '11',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox
              checked={checkboxObj['opencv-python']}
              onChange={() => {
                handleMenuClick('opencv-python');
              }}
            />
          </div>

          <div className='col-1'>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/32/OpenCV_Logo_with_text_svg_version.svg"
              alt="OpenCV Logo"
              style={{ width: '20px', height: '20px' }}
            />
          </div>

          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>opencv (cv2)</span><br />
            <span className='text-muted text-break'>
              A computer vision library for image and video processing, used for tasks like face detection and object recognition.
            </span>
            <div className='wrap-addplugin' onClick={() => handleMenuClick('opencv-python')}>
              {checkboxObj['opencv-python'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '12',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox
              checked={checkboxObj['wikipedia']}
              onChange={() => {
                handleMenuClick('wikipedia');
              }}
            />
          </div>

          <div className='col-1'>
            <img
              src="https://en.wikipedia.org/static/images/icons/wikipedia.png"
              alt="Wikipedia Logo"
              style={{ width: '20px', height: '20px' }}
            />
          </div>

          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>wikipedia</span><br />
            <span className='text-muted text-break'>
              A Python library that wraps the Wikipedia API to easily fetch article summaries, content, and search results.
            </span>
            <div className='wrap-addplugin' onClick={() => handleMenuClick('wikipedia')}>
              {checkboxObj['wikipedia'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '11',
      colorBgElevated: '#232F34',
      label: (
        <div className='row plugin-item' style={{ cursor: 'auto' }}>
          <div className='col-1'>
            <Checkbox
              checked={checkboxObj['mysqlConnector']}
              onChange={() => {
                handleMenuClick('mysqlConnector');
              }}
            />
          </div>
    
          <div className='col-1'>
            <img
              src={pymysqlLogo}
              alt="MySQL Connector Logo"
              style={{ width: '25px', height: '25px' }}
            />
          </div>
    
          <div className='col-10' style={{ paddingLeft: '20px' }}>
            <span>mysqlConnector</span><br />
            <span className='text-muted text-break'>
              MySQL Connector for Python to connect to MySQL databases.
            </span>
            <div className='wrap-addplugin' onClick={() => handleMenuClick('mysqlConnector')}>
              {checkboxObj['mysqlConnector'] ? <span>Remove</span> : <span>Add</span>}
            </div>
          </div>
        </div>
      ),
    }
  ];

  return (
    <Dropdown
      menu={{items}}
      trigger={['click']}
      open={open}
      onOpenChange={handleOpenChange}
      placement="bottomRight"
      dropdownRender={(menu) => (
        <div style={contentStyle}>
          {React.cloneElement(menu, {
            style: menuStyle,
          })}
          <Space
            style={{
              padding: 8,
              alignSelf: 'flex-end', // Align the button to the right
            }}
          >
            <Button type="primary" onClick={handleSubmitPackages}>Add selected</Button>
          </Space>
        </div>
      )}
    >
      <Button style={{color: '#404040'}}>
        <PlusOutlined /> Manage Packages
      </Button>
    </Dropdown>
  );
};

export default PluginsLoader;
